import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLauncherReadSpeakerComponent } from './button-launcher-read-speaker.component';
import { WordingModule } from '../../../pipes';

@NgModule({
  imports: [CommonModule, WordingModule, ButtonLauncherReadSpeakerComponent],
  exports: [ButtonLauncherReadSpeakerComponent],
})
export class ButtonLauncherReadSpeakerModule {}
